import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { QueryFlagLabels, QueryFlagTooltips, QueryFlags } from "../../../utils/types";
import Autocomplete from "../../library/Autocomplete";
import { checkForMatch } from "../../../utils/misc";

interface QueryFlagsAutocompleteProps {
  onChange: (newSelected:QueryFlags[]) => void;
  reactRef: any;
  selected: QueryFlags[];
}
interface FilterProps {
  text: string
}

function QueryFlagsAutocomplete(props: QueryFlagsAutocompleteProps) {
  const labelKeyFunction = (option: QueryFlags) => {
    return QueryFlagLabels[option];
  }

  const filterQueryFlags = (option: QueryFlags, props: FilterProps) => {
    if (props.text == null || props.text.length === 0) return true;

    const searchString = (props.text as string).trim().toLowerCase();
    const searchStrings:string[] = searchString.split(" ");

    return checkForMatch(searchStrings, QueryFlagLabels[option].toLowerCase());
  }

  const handleCheckboxClick = (e:any, selectedValue:QueryFlags) => {
    e.stopPropagation();
    e.preventDefault();

    // Only send the clicked value - queryFlagsOnChange handles the toggle logic
    props.onChange([selectedValue]);
  }

  const handleRegularOnChange = (selected: QueryFlags[]) => {
    // Check if this is a clear all action (clear button)
    if (selected.length === 0 && props.selected && props.selected.length > 0) {
      // Send all current items to toggle them all off
      props.onChange(props.selected);
      return;
    }

    // Check if this is a single X button removal (items were removed)
    const isRemoval = selected.length < (props.selected?.length || 0);

    if (isRemoval) {
      // Find which item was removed
      const removedItem = props.selected?.find((item: QueryFlags) =>
        !selected.includes(item)
      );

      if (removedItem) {
        // Send just the removed item to toggle it off
        props.onChange([removedItem]);
        return;
      }
    }

    // Otherwise ignore - checkbox handles additions
  };

  const renderMenuItemChildren = (option: (QueryFlags)) => {
    const menuItem = (
      <div
        style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", cursor: "pointer", padding: "0.25rem 1rem" }}
        onClick={(e) => handleCheckboxClick(e, option)}
      >
        <OverlayTrigger
          key={option}
          placement="auto"
          overlay={( props ) => {
            return (
              <Tooltip {...props} id={option}>
                {QueryFlagTooltips[option]}
              </Tooltip>
            );
          }
        }>
          <div style={{ cursor: "pointer", display: "inline-block" }}>
            <Form.Check
              inline
              readOnly
              style={{ whiteSpace: "nowrap", cursor: "pointer" }}
              type="checkbox"
              checked={props.selected.includes(option)}
              onClick={(e) => {
                e.stopPropagation(); // Prevent double firing
                handleCheckboxClick(e, option);
              }}
              label={QueryFlagLabels[option]}
            />
          </div>
        </OverlayTrigger>
      </div>
    )

    return menuItem;
  };

  return (
    <Autocomplete
      id="queryFlagsAutocomplete"
      className="autocomplete-keep-open"
      placeholder="Query Flags"
      reactKey="queryFlagsAutocomplete"
      labelKey={labelKeyFunction}
      filterBy={filterQueryFlags}
      renderMenuItemChildren={renderMenuItemChildren}
      onChange={handleRegularOnChange}
      options={Object.values(QueryFlags)}
      selected={props.selected}
      reactRef={props.reactRef}
      multiple
    />
  );
}

export default QueryFlagsAutocomplete;